
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 1.5h3.158v1.028H1.053v16.444h17.894V2.528h-2.105V1.5H20V20H0V1.5z","fill":"#979797"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.842 1.5h6.316v1H6.842v-1z","fill":"#979797"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.421 0h1.684c.698 0 1.263.478 1.263 1.067v1.866C7.368 3.523 6.803 4 6.105 4H4.421c-.698 0-1.263-.478-1.263-1.067V1.067C3.158.477 3.723 0 4.421 0zm0 .889c-.116 0-.21.08-.21.178v1.866c0 .099.094.178.21.178h1.684c.117 0 .21-.08.21-.178V1.067c0-.099-.093-.178-.21-.178H4.421zM13.895 0h1.684c.698 0 1.263.478 1.263 1.067v1.866c0 .59-.565 1.067-1.263 1.067h-1.684c-.698 0-1.263-.478-1.263-1.067V1.067c0-.59.565-1.067 1.263-1.067zm0 .889c-.117 0-.21.08-.21.178v1.866c0 .099.093.178.21.178h1.684c.116 0 .21-.08.21-.178V1.067c0-.099-.094-.178-.21-.178h-1.684z","fill":"#908F8D"}}),_c('path',{attrs:{"d":"M.526 5h18.948v1H.526V5z","fill":"#979797"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.526 8.5v2h2.106v-2h-2.106zm-1.052 0v2H7.368v-2h2.106zm0-1h7.368v10H3.158v-10h6.316zm-3.158 1H4.21v2h2.105v-2zm-2.105 3v2h2.105v-2H4.21zm0 3v2h2.105v-2H4.21zm3.157 2h2.106v-2H7.368v2zm3.158 0h2.106v-2h-2.106v2zm3.158 0h2.106v-2h-2.106v2zm2.106-3v-2h-2.106v2h2.106zm0-3v-2h-2.106v2h2.106zm-5.264 1h2.106v2h-2.106v-2zm-3.158 0v2h2.106v-2H7.368z","fill":"#908F8D"}})])
          )
        }
      }
    